import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface Props {
  isAdmin: boolean;
}

export function ActionRail({ isAdmin }: Props): JSX.Element {
  const { t } = useTranslation();

  const links: Array<{ to: string; labelKey: string }> = [
    { to: "/chat", labelKey: "dashboard.reviewConsole.actions.chat" },
    { to: "/documents", labelKey: "dashboard.reviewConsole.actions.documents" },
    { to: "/subjects", labelKey: "dashboard.reviewConsole.actions.subjects" },
    isAdmin
      ? {
          to: "/admin/promotions",
          labelKey: "dashboard.reviewConsole.actions.adminReview",
        }
      : {
          to: "/my-promotions",
          labelKey: "dashboard.reviewConsole.actions.myPromotions",
        },
  ];

  if (isAdmin) {
    links.push({
      to: "/teacher/state",
      labelKey: "dashboard.reviewConsole.actions.teacherState",
    });
  }

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5">
      <h3 className="text-sm font-semibold text-white">
        {t("dashboard.reviewConsole.actions.heading")}
      </h3>
      <div className="mt-3 flex flex-wrap gap-2">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs font-semibold text-slate-900 transition hover:bg-slate-100"
          >
            {t(l.labelKey)}
          </Link>
        ))}
      </div>
    </section>
  );
}
